import { render, staticRenderFns } from "./BtnAdicionarGrupo.vue?vue&type=template&id=8df83354&scoped=true&"
import script from "./BtnAdicionarGrupo.vue?vue&type=script&lang=js&"
export * from "./BtnAdicionarGrupo.vue?vue&type=script&lang=js&"
import style0 from "./BtnAdicionarGrupo.vue?vue&type=style&index=0&id=8df83354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df83354",
  null
  
)

export default component.exports